import { render, staticRenderFns } from "./TranslateChannels.vue?vue&type=template&id=d5995b92&scoped=true"
import script from "./TranslateChannels.vue?vue&type=script&lang=js"
export * from "./TranslateChannels.vue?vue&type=script&lang=js"
import style0 from "./TranslateChannels.vue?vue&type=style&index=0&id=d5995b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5995b92",
  null
  
)

export default component.exports